<template>
  <v-card class="elevation-12">
    <template v-if="tempMail">
      <v-toolbar color="primary" dark>
        {{ tempMail.uid }}
      </v-toolbar>
      <v-card-actions>
        <v-btn color="primary" @click="onGoBackClicked">Назад</v-btn>
        <v-spacer/>
        <v-btn color="success" v-if="!tempMail.isApproved" @click="approveDialog= true">
          Подтвердить
        </v-btn>
      </v-card-actions>

      <v-card-text>
        <object width="100%" height="1200px" type="application/pdf" :data="pdfObjectData">
          <p>Пожалуйста обновите пожалуйста браузер</p>
        </object>
      </v-card-text>
    </template>

    <v-dialog v-model="approveDialog" max-width="480px" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">
          Вы действительн хотите подтвердить письмо?
        </v-card-title>

        <v-card-text>
          Письмо пойдет на дальнейщую обработку, отменить возможности небудет
        </v-card-text>

        <v-card-actions>
          <v-btn color="default" text @click="approveDialog = false" :disabled="loading">
            Закрыть
          </v-btn>
          <v-spacer/>
          <v-btn color="success" text dark @click="onApproveButtonClicked" :disabled="loading">Да, Подтвердить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import RegistryService from "@/services/registry.service"
import Mappers from "@/mappers"

export default {
  name: "TempMailView",
  data() {
    return {
      tempMail: null,
      loading: false,
      approveDialog: false
    }
  },
  computed: {
    pdfObjectData() {
      return this.tempMail ? `${RegistryService.getPdfPath(this.tempMail.uid)}?#zoom=100` : ""
    },
  },
  methods: {
    onGoBackClicked() {
      this.$router.go(-1)
    },
    onApproveButtonClicked() {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)

      RegistryService.approveRegistryMail(this.tempMail.uid)
          .then(() => {
            this.loadMail()
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    loadMail() {
      this.tempMail = null
      this.loading = true
      this.approveDialog = false
      this.$store.dispatch(LAYOUT_LOADING_START)

      RegistryService.getTempMail(this.$route.params.uid)
          .then(response => {
            this.tempMail = Mappers.mapTempMail(response.data)
          }, () => {
            this.$router.go(-1)
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    this.loadMail()
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Просмотр письма")
  },
  watch: {
    "$route": function () {
      this.loadMail()
    }
  }
}
</script>

<style scoped>

</style>